/**
 * How an invoice gets emailed: at the first sweep after approval (the default),
 * on a chosen date, or only when someone presses Send. The API holds this as
 * `sendOnApproval` + `scheduledSendOn`; one choice here keeps the three
 * mutually exclusive on screen too.
 *
 * Shared by the invoice editor and the list page's bulk reschedule, so both
 * offer the same three choices in the same words.
 */
export const SEND_MODES = ['approval', 'date', 'manual'] as const;
export type SendMode = (typeof SEND_MODES)[number];
export const SEND_MODE_LABELS: Record<SendMode, string> = {
  approval: 'As soon as it’s approved',
  date: 'On a date',
  manual: 'Manually',
};
